import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import MainLayout from "./layout/MainLayout";
import { SoftwareCompanySchema, ServicesSchema } from "./components/SEO";
import RouteFallback from "./components/RouteFallback";
import Home from "./pages/Home";

const AboutPage = lazy(() => import(/* webpackChunkName: "page-about" */ "./pages/AboutPage"));
const ServicesPage = lazy(() => import(/* webpackChunkName: "page-services" */ "./pages/ServicesPage"));
const ServiceDetailPage = lazy(() => import(/* webpackChunkName: "page-service-detail" */ "./pages/ServiceDetailPage"));
const PortfolioPage = lazy(() => import(/* webpackChunkName: "page-portfolio" */ "./pages/PortfolioPage"));
const CaseStudyPage = lazy(() => import(/* webpackChunkName: "page-case-study" */ "./pages/CaseStudyPage"));
const TestimonialsPage = lazy(() => import(/* webpackChunkName: "page-testimonials" */ "./pages/TestimonialsPage"));
const BlogPage = lazy(() => import(/* webpackChunkName: "page-blog" */ "./pages/BlogPage"));
const BlogCategoryPage = lazy(() => import(/* webpackChunkName: "page-blog-category" */ "./pages/BlogCategoryPage"));
const BlogPostPage = lazy(() => import(/* webpackChunkName: "page-blog-post" */ "./pages/BlogPostPage"));
const ContactPage = lazy(() => import(/* webpackChunkName: "page-contact" */ "./pages/ContactPage"));
const FAQPage = lazy(() => import(/* webpackChunkName: "page-faq" */ "./pages/FAQPage"));
const PrivacyPage = lazy(() => import(/* webpackChunkName: "page-privacy" */ "./pages/PrivacyPage"));
const TermsPage = lazy(() => import(/* webpackChunkName: "page-terms" */ "./pages/TermsPage"));
const LocationSuratPage = lazy(() => import(/* webpackChunkName: "page-surat" */ "./pages/LocationSuratPage"));
const GetProposalPage = lazy(() => import(/* webpackChunkName: "page-proposal" */ "./pages/GetProposalPage"));
const HireDevelopersPage = lazy(() => import(/* webpackChunkName: "page-hire" */ "./pages/HireDevelopersPage"));

function App() {
  return (
    <HelmetProvider>
      <SoftwareCompanySchema />
      <ServicesSchema />

      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/work/:slug" element={<CaseStudyPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/category/:slug" element={<BlogCategoryPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/hire-developers" element={<HireDevelopersPage />} />
            <Route path="/get-proposal" element={<GetProposalPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/locations/surat-gujarat" element={<LocationSuratPage />} />
            <Route path="/software-development-company-surat" element={<Navigate to="/locations/surat-gujarat" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
